import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  padded?: boolean;
}

export default function Card({ children, className, padded = true, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-background-200 bg-background-50 shadow-xs transition-all duration-200 ease-smooth',
        'hover:-translate-y-0.5 hover:border-background-300 hover:shadow-card',
        padded && 'p-4 md:p-5',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}